function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import assign from 'lodash/assign';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import includes from 'lodash/includes';
import map from 'lodash/map';
import assignWith from 'lodash/assignWith';
import partition from 'lodash/partition';
import pick from 'lodash/pick';
import unset from 'lodash/unset';
import uniqBy from 'lodash/uniqBy';
import { all, call, getContext, put, select, takeLatest } from 'redux-saga/effects';
import AlertService from 'services/AlertService';
import OidcService from 'services/OidcService';
import { serializeQuery } from 'helpers/urlTools';
import { compactObject } from 'helpers/transformers';
import ApiService from 'services/ApiService';
import App from 'modules/App';
import { imageUrlToBase64 } from 'helpers/convertToBase64';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selectors';
import messages from './messages';
// INFORMATION ---------------------------------------------------------------------------------------------------------
// eslint-disable-next-line consistent-return
function* fetchAvatarImg({ avatarSrc }) {
    const fetch = yield getContext('fetch');
    try {
        const avatarImg = yield call(fetch, avatarSrc);
        const convertedAvatar = yield imageUrlToBase64(avatarImg);
        yield put(actions.fetchProfileAvatarSuccess(convertedAvatar));
        return yield convertedAvatar;
    } catch (err) {
        yield put(actions.fetchProfileAvatarError(err));
        yield call(App.dispatchError, err, messages);
    }
}
function* getInformation() {
    try {
        const requestUrl = '/api/Information/Account';
        return yield call(ApiService.regionalRequest, requestUrl);
    } catch (err) {
        yield call(App.dispatchError, err);
    }
    return null;
}
function* getIdentityInformation(identity) {
    try {
        const { identityUID, countryCode } = identity;
        const region = yield call(ApiService.findRegionByCountry, countryCode);
        const requestUrl = `/api/Information/Identity/${identityUID}`;
        return yield call(ApiService.crossRegionalRequest, region, requestUrl);
    } catch (err) {
        yield call(App.dispatchError, err);
    }
    return null;
}
function* getInformationTemplate(scopeName, countryCode) {
    const query = serializeQuery({
        scope: scopeName,
        countryCode
    });
    const requestUrl = `/api/Information/Account/Template?${query}`;
    return yield call(ApiService.originalRequest, requestUrl);
}
function* getConsentsTemplate(countryCode) {
    const requestUrl = `/api/Localization/legalConsents?countryCode=${countryCode}`;
    return yield call(ApiService.originalRequest, requestUrl);
}
function analyzeInformationIntegrity(information, informationTemplate, consentsTemplate) {
    let isNoMandatoryConsent = false;
    let isNoMandatoryInformation = false;
    // const [mandatoryConsents, optionalConsents] = partition(consentsTemplate, { isMandatory: true });
    const [mandatoryConsents] = partition(consentsTemplate, {
        isMandatory: true
    });
    for(let i = 0; i < mandatoryConsents.length; i++){
        const { legalConsentId, type } = mandatoryConsents[i];
        const approval = find(information.legalConsentApprovals, {
            legalConsentId
        });
        if (!approval || !approval.decision) {
            if (type === 'TermsOfService') {
                isNoMandatoryConsent = true;
            } else {
                isNoMandatoryInformation = true;
            }
        }
    }
    // for (let i = 0; i < optionalConsents.length; i++) {
    //   const { legalConsentId } = optionalConsents[i];
    //   const approval = find(information.legalConsentApprovals, { legalConsentId });
    //   if (!approval) {
    //     isNoMandatoryInformation = true;
    //     break;
    //   }
    // }
    if (!isNoMandatoryInformation) {
        for(let i = 0; i < informationTemplate.length; i++){
            const ft = informationTemplate[i];
            let value = get(information, ft.name);
            if (ft.type === 'group') {
                forEach(ft.fields, (f)=>{
                    if (f.options) {
                        const optionValue = get(value, f.name);
                        const optionTemplateValues = map(f.options, (o)=>o.value);
                        if (!includes(optionTemplateValues, optionValue)) {
                            value = undefined;
                            unset(information, ft.name);
                        }
                    }
                });
            }
            if (!value && ft.isMandatory) {
                isNoMandatoryInformation = true;
                break;
            }
        }
    }
    return {
        isNoMandatoryConsent,
        isNoMandatoryInformation
    };
}
function* fetchConsentsTemplate({ payload }) {
    try {
        const { countryCode } = payload;
        const consentsTemplate = yield call(getConsentsTemplate, countryCode);
        yield put(actions.fetchConsentsTemplateSuccess(consentsTemplate));
    } catch (err) {
        yield put(actions.fetchConsentsTemplateError(err));
        yield call(App.dispatchError, err);
    }
}
function* checkInformation({ payload }) {
    const assetUrl = yield getContext('assetUrl');
    const code = yield select(App.selectors.regionName);
    try {
        const { additionalInformationIdentities } = payload;
        const tokenData = yield call(OidcService.getTokenData);
        const scopeName = get(tokenData, 'identity_scope');
        const countryCode = get(tokenData, 'identity_country_code');
        const calls = [
            call(getInformation),
            call(getInformationTemplate, scopeName, countryCode),
            call(getConsentsTemplate, countryCode)
        ];
        forEach(additionalInformationIdentities, (identity)=>calls.push(call(getIdentityInformation, identity)));
        const results = yield all(calls);
        const [information, informationTemplate, consentsTemplate] = results;
        const { isNoMandatoryConsent, isNoMandatoryInformation } = analyzeInformationIntegrity(information, informationTemplate, consentsTemplate);
        const additionalInformation = results.slice(3).map((ai)=>compactObject(pick(ai, constants.BASIC_INFORMATION)));
        const fullInformation = assign(...additionalInformation, information);
        if (information.avatar && !information.avatar.includes('data:image')) {
            yield call(fetchAvatarImg, {
                avatarSrc: `${assetUrl}/${code}/${information.avatar}`
            });
        }
        yield put(actions.checkInformationSuccess({
            information: fullInformation,
            informationTemplate,
            consentsTemplate,
            isNoMandatoryConsent,
            isNoMandatoryInformation
        }));
    } catch (err) {
        yield put(actions.checkInformationError(err));
        yield call(App.dispatchError, err);
    }
}
function* sendInformation({ payload, successMessage }) {
    try {
        const { information } = payload;
        const currentInformation = yield select(selectors.information);
        const correctAvatar = information.avatar && information.avatar.includes('base64') ? information.avatar : currentInformation.base64Avatar;
        const requestUrl = '/api/Information/Account';
        yield call(ApiService.regionalRequest, requestUrl, {
            method: 'PUT',
            body: _object_spread_props(_object_spread({}, information), {
                avatar: correctAvatar
            })
        });
        const assignCustomizer = (objValue, srcValue, key)=>{
            if (key === 'legalConsentApprovals') {
                return uniqBy([
                    ...srcValue,
                    ...objValue
                ], 'legalConsentId');
            }
            return undefined;
        };
        const updatedInformation = assignWith(_object_spread({}, currentInformation), information, assignCustomizer);
        const informationTemplate = yield select(selectors.informationTemplate);
        const consentsTemplate = yield select(selectors.consentsTemplate);
        const { isNoMandatoryConsent, isNoMandatoryInformation } = analyzeInformationIntegrity(updatedInformation, informationTemplate, consentsTemplate);
        yield put(actions.sendInformationSuccess({
            information: updatedInformation,
            informationTemplate,
            consentsTemplate,
            isNoMandatoryConsent,
            isNoMandatoryInformation
        }));
        const alert = yield call(AlertService.createAlertDispatcher);
        yield alert.success(successMessage || messages.alerts.sendInformationSuccess);
    } catch (err) {
        yield put(actions.sendInformationError(err));
        yield call(App.dispatchError, err);
    }
}
//----------------------------------------------------------------------------------------------------------------------
function* sagas() {
    yield takeLatest(actionTypes.CHECK_INFORMATION, checkInformation);
    yield takeLatest(actionTypes.FETCH_CONSENTS_TEMPLATE, fetchConsentsTemplate);
    yield takeLatest(actionTypes.SEND_INFORMATION, sendInformation);
    yield takeLatest(actionTypes.FETCH_PROFILE_AVATAR, fetchAvatarImg);
}
export default [
    sagas
];
